import { render, staticRenderFns } from "./SectorAddUpdate.vue?vue&type=template&id=7725ca18"
import script from "./SectorAddUpdate.vue?vue&type=script&lang=js"
export * from "./SectorAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports